import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import get from 'lodash/get'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/apir/v11`,
  validateStatus (status) {
    return status === 200
  },
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

instance.interceptors.request.use(
  config => {
    const company = store.state.auth.company || ''
    const username = store.state.auth.user.user || ''
    const token = store.state.auth.token || ''
    config.headers.Authorization = `Bearer ${btoa(`${company}/${username}:${token}`)}`

    return config
  },
  error => Promise.reject(error)
)

instance.interceptors.response.use(
  response => response,
  error => {
    if (router.currentRoute.name !== 'login' && get(error, 'response.status', 0) === 401) {
      store.dispatch('auth/logoutWithoutRequest')
      router.push({ name: 'login', query: { redirect: window.location.href.replace(/^\//g, '') }})
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
)

Vue.prototype.$axios = instance

export default instance
